import api from 'api';

export default async ({ asPath, req }) => {
  try {
    const pathId = parseInt(asPath.split('/')[3], 10);
    const headers = req ? { Cookie: req.headers.cookie } : {};
    const paths = await api.get(`/admin/paths?id=${pathId}`, {
      headers
    });
    if (!paths.data.paths || !paths.data.paths.length) {
      const error = new Error();
      error.response = { status: 404 };
      throw error;
    }
    return paths.data.paths[0];
  } catch (error) {
    return null;
  }
};
